module.exports = __webpack_public_path__ + "static/media/phone.72a1cbe6.svg";